<template>
  <div v-if="show" class="modal-overlay" @click.self="close">
    <div class="modal-content">
      <div class="modal-header">
        <h3>{{ title }}</h3>
        <button class="modal-close" @click="close">Close</button>
      </div>
      <div class="modal-body doc">
        <h2>Investor Charter in respect of Investment Adviser (IA)</h2>

        <h3>A. Vision and Mission Statements for Investors</h3>
        <p><strong>Vision :</strong> Invest with knowledge &amp; safety.</p>
        <p><strong>Mission :</strong> Every investor should be able to invest in right investment products based on their needs, manage and monitor them to meet their goals, access reports and enjoy financial wellness.</p>

        <h3>B. Details of Business Transacted by the Investment Adviser with respect to the Investors</h3>
        <ul>
          <li>To enter into an agreement with the client providing all details including fee details, aspects of Conflict of interest disclosure and maintaining confidentiality of information.</li>
          <li>To do a proper and unbiased risk-profiling and suitability assessment of the client.</li>
          <li>To conduct audit annually.</li>
          <li>To disclose the status of complaints on its website.</li>
          <li>To disclose the name, proprietor name, type of registration, registration number, validity, complete address with telephone numbers and associated SEBI Office details (i.e. Head office/ regional/ local Office) on its website.</li>
          <li>To employ only qualified and certified employees.</li>
          <li>To deal with clients only from official number.</li>
          <li>To maintain records of interactions, with all clients including prospective clients (prior to onboarding), where any conversation related to advice has taken place.</li>
          <li>To ensure that all advertisements are in adherence to the provisions of the Advertisement Code for Investment Advisers.</li>
          <li>Not to discriminate in terms of services provided, among clients opting for same/similar products/services offered by investment adviser.</li>
        </ul>

        <h3>C. Details of Services Provided to Investors (No Indicative Timelines)</h3>
        <h4>Onboarding of Clients</h4>
        <ul>
          <li>Sharing of agreement copy</li>
          <li>Completing KYC of clients</li>
        </ul>
        <h4>Disclosure to Clients</h4>
        <ul>
          <li>To provide full disclosure about its business, affiliations, compensation in the agreement.</li>
          <li>To not access client's accounts or holdings for offering advice.</li>
          <li>To disclose the risk profile to the client.</li>
          <li>To disclose any conflict of interest of the investment advisory activities with any other activities of the investment adviser.</li>
          <li>To disclose the extent of use of Artificial Intelligence tools in providing investment advisory services.</li>
          <li>Details of grievance redressal mechanism and how to access it.</li>
          <li>To provide investment advice to the client based on the risk-profiling of the clients and suitability of the client.</li>
          <li>To treat all advisory clients with honesty and integrity.</li>
          <li>To make adequate disclosure to the investor of all material facts such as risks, obligations, costs, etc. relating to the products or securities advised by the adviser.</li>
          <li>To provide clear guidance and adequate caution notice to clients when providing investment advice for dealing in complex and high-risk financial products/services.</li>
          <li>To ensure confidentiality of information shared by clients unless such information is required to be provided in furtherance of discharging legal obligations or a client has provided specific consent to share such information.</li>
          <li>To disclose the timelines for the various services provided by the investment adviser to clients and ensure adherence to the said timelines.</li>
        </ul>

        <h3>D. Details of Grievance Redressal Mechanism and How to Access It</h3>
        <p><strong>1. Investor can lodge complaint/grievance against Investment Adviser in the following ways:</strong></p>
        <h4>Mode of filing the complaint with Investment Adviser:</h4>
        <p>In case of any grievance / complaint, an investor may approach the concerned Investment Adviser who shall strive to redress the grievance immediately, but not later than 21 days of the receipt of the grievance.</p>
        <h4>Mode of filing the complaint on SCORES or with Investment Adviser Administration and Supervisory Body (IAASB):</h4>
        <ul>
          <li>SCORES 2.0 (a web-based centralized grievance redressal system of SEBI for facilitating effective grievance redressal in time-bound manner)
            <ul><li><a href="https://scores.sebi.gov.in" target="_blank" rel="noopener noreferrer">https://scores.sebi.gov.in</a></li></ul>
          </li>
          <li>Two level review for complaint/grievance against investment adviser:
            <ul>
              <li>First review done by designated body (IAASB)</li>
              <li>Second review done by SEBI</li>
            </ul>
          </li>
          <li>Email to designated email ID of IAASB</li>
        </ul>
        <p><strong>2.</strong> If the investor is not satisfied with the resolution provided by the Market Participants, then the investor has the option to file the complaint/grievance on the SMARTODR platform for its resolution through online conciliation or arbitration.</p>
        <p><strong>3.</strong> With regard to physical complaints, investors may send their complaints to:</p>
        <p>
          Office of Investor Assistance and Education<br />
          Securities and Exchange Board of India<br />
          SEBI Bhavan, Plot No. C4-A, ‘G’ Block<br />
          Bandra-Kurla Complex, Bandra (E)<br />
          Mumbai – 400 051
        </p>

        <h3>E. Rights of Investors</h3>
        <ul>
          <li>Right to Privacy and Confidentiality</li>
          <li>Right to Transparent Practices</li>
          <li>Right to fair and Equitable Treatment</li>
          <li>Right to Adequate Information</li>
          <li>Right to Initial and Continuing Disclosure
            <ul><li>– Right to receive information about all the statutory and regulatory disclosures.</li></ul>
          </li>
          <li>Right to Fair &amp; True Advertisement</li>
          <li>Right to Awareness about Service Parameters and Turnaround Times
            <ul><li>Right to be informed of the timelines for each service.</li></ul>
          </li>
          <li>Right to be Heard and Satisfactory Grievance Redressal
            <ul><li>Right to have timely redressal.</li></ul>
          </li>
          <li>Right to Suitability of the Financial Products</li>
          <li>Right to Exit from Financial product or service in accordance with the terms of agreement with the investment adviser</li>
          <li>Right to receive clear guidance and caution notice when dealing in Complex and High-Risk Financial Products and Services</li>
          <li>Additional Rights to vulnerable consumers
            <ul><li>– Right to get access to services in a suitable manner even if differently abled.</li></ul>
          </li>
          <li>Right to provide feedback on the financial products and services used</li>
          <li>Right against coercive, unfair, and one-sided clauses in financial agreements</li>
          <li>Right to have digital accessibility</li>
        </ul>

        <h3>F. Expectations from the Investors (Responsibilities of Investors)</h3>
        <h4>Do's</h4>
        <ul>
          <li>Always deal with SEBI registered Investment Advisers.</li>
          <li>Ensure that the Investment Adviser has a valid registration certificate.</li>
          <li>Check for SEBI registration number.</li>
          <li>Please refer to the list of all SEBI registered Investment Advisers which is available on SEBI website in the following link: <a href="https://www.sebi.gov.in/sebiweb/other/OtherAction.do?doRecognisedFpi=yes&intmId=13" target="_blank" rel="noopener noreferrer">https://www.sebi.gov.in/sebiweb/other/OtherAction.do?doRecognisedFpi=yes&amp;intmId=13</a></li>
          <li>Pay only advisory fees to your Investment Adviser. Make payments of advisory fees through banking channels only and maintain duly signed receipts mentioning the details of your payments.</li>
          <li>You may make payment of advisory fees through Centralised Fee Collection Mechanism (CeFCoM) of IAASB if investment adviser has opted for the mechanism.</li>
          <li>Always ask for your risk profiling before accepting investment advice. Insist that Investment Adviser provides advisory strictly on the basis of your risk profiling and take into account available investment alternatives.</li>
          <li>Ask all relevant questions and clear your doubts with your Investment Adviser before acting on advice.</li>
          <li>Assess the risk-return profile of the investment as well as the liquidity and safety aspects before making investments.</li>
          <li>Insist on getting the terms and conditions in writing duly signed and stamped. Read these terms and conditions carefully particularly regarding advisory fees, advisory plans, category of recommendations etc. before dealing with any Investment Adviser.</li>
          <li>Be vigilant in your transactions.</li>
          <li>Approach the appropriate authorities for redressal of your doubts / grievances.</li>
          <li>Inform SEBI about Investment Advisers offering assured or guaranteed returns.</li>
          <li>Always be aware that you have the right to exit the service of an Investment Adviser.</li>
          <li>Always be aware that you have the right to seek clarifications and clear guidance on advice.</li>
          <li>Always be aware that you have the right to provide feedback to the Investment Adviser in respect of services received.</li>
          <li>Always be aware that you will not be bound by any clause, prescribed by the investment adviser, which is contravening any regulatory provisions.</li>
        </ul>
        <h4>Don'ts</h4>
        <ul>
          <li>Don't fall for stock tips offered under the pretext of investment advice.</li>
          <li>Do not provide funds for investment to the Investment Adviser.</li>
          <li>Don't fall for the promise of indicative or exorbitant or assured returns by the Investment Advisers. Don't let greed overcome rational investment decisions.</li>
          <li>Don't fall prey to luring advertisements or market rumors.</li>
          <li>Avoid doing transactions only on the basis of phone calls or messages from any Investment adviser or its representatives.</li>
          <li>Don't take decisions just because of repeated messages and calls by Investment Advisers.</li>
          <li>Do not fall prey to limited period discount or other incentive, gifts, etc. offered by Investment advisers.</li>
          <li>Don't rush into making investments that do not match your risk taking appetite and investment goals.</li>
          <li>Do not share login credential and password of your trading, demat or bank accounts with the Investment Adviser.</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  show: { type: Boolean, default: false },
  title: { type: String, default: 'Investor Charter' },
  pdfPath: { type: String, default: '' }
});

const emit = defineEmits(['close']);
const close = () => emit('close');
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
}
.modal-content {
  width: 100%;
  max-width: 980px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}
.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
}
.modal-header h3 { margin: 0; }
.modal-close { background: transparent; border: 0; cursor: pointer; color: #1f2937; font-weight: 700; }
.modal-body { padding: 16px 24px; overflow-y: auto; }
.doc { color: #1f2937; line-height: 1.6; font-size: 0.95rem; }
.doc h2 { font-size: 1.4rem; margin: 0 0 16px; }
.doc h3 { font-size: 1.1rem; margin: 22px 0 8px; color: #0e38d2; }
.doc h4 { font-size: 1rem; margin: 14px 0 6px; }
.doc p { margin: 6px 0; }
.doc ul { margin: 6px 0; padding-left: 22px; }
.doc li { margin: 4px 0; }
.doc a { color: #3b82f6; word-break: break-all; }
</style>
